export default {"src":"/_next/static/media/debugging.1b105fae.svg","height":64,"width":64};